export enum LSPAY_ECOM_ERROR_CODE {
  DEFAULT_REFUND = 'DEFAULT_REFUND',
  // Requested refund amount exceeds the available refund amount for this order
  TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED = 'TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED',
  // Order already fully refunded
  TYPE_CLIENT_ERROR_ALREADY_REFUNDED = 'TYPE_CLIENT_ERROR_ALREADY_REFUNDED',
  // Trying refund with a poistive value
  TYPE_CLIENT_ERROR_AMOUNT_INVALID = 'TYPE_CLIENT_ERROR_AMOUNT_INVALID',
}

export const LSPAY_ECOM_ERRORS = [
  LSPAY_ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_AMOUNT_EXCEEDED,
  LSPAY_ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_ALREADY_REFUNDED,
  LSPAY_ECOM_ERROR_CODE.TYPE_CLIENT_ERROR_AMOUNT_INVALID,
]
